"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartIcon = void 0;
var _icons = require("@ori-ui/icons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HeartIcon = ({
  isFavorite,
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.HeartIconRoot, {
  onClick: onClick,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Filled, {
    isFavorite: isFavorite,
    className: "filledIcon",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.HeartFilled, {
      fontSize: "inherit"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Outlined, {
    isFavorite: isFavorite,
    className: "outlinedIcon",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Heart, {
      fontSize: "inherit"
    })
  })]
});
exports.HeartIcon = HeartIcon;
